'use client';

import type { ScheduleItem, ScheduleKind } from '@/packages/sxm/sports/scheduleItems';
import { isSoccerLeague } from '@/packages/sxm/sports/scheduleConfig';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { ScheduleFilters } from './ScheduleFilters';
import { ScheduleList } from './ScheduleList';
import { ScheduleReminder, type ScheduleReminderProps } from './ScheduleReminder';
import { useScheduleFilters } from './useScheduleFilters';
import styles from './sportschedule.module.scss';

export interface LeagueScheduleProps {
    kind: ScheduleKind;
    items: ScheduleItem[];
    leagueAbbr: string;
    renderedAt: number;
    reminder: ScheduleReminderProps;
}

export default function LeagueSchedule({ kind, items, leagueAbbr, renderedAt, reminder }: LeagueScheduleProps) {
    const filters = useScheduleFilters({ items, leagueAbbr, renderedAt });
    const conferenceLabels = { true: 'League', false: 'Conference' };

    return (
        <Grid container className={styles.scheduleContainer}>
            <Grid col={{ sm: 12, lg: 10 }} start={{ lg: 2 }}>
                <ScheduleFilters
                    itemLabel={kind}
                    conferenceLabel={conferenceLabels[`${isSoccerLeague(leagueAbbr)}`]}
                    dateOptions={filters.dateOptions}
                    dateValue={filters.dateValue}
                    dateLabel={filters.dateLabel}
                    onDateChange={filters.setDate}
                    conferenceOptions={filters.conferenceOptions}
                    conference={filters.conference}
                    onConferenceChange={filters.setConference}
                />
                <ScheduleList days={filters.days} timeZone={filters.timeZone} />
                <div className={styles.reminder}>
                    <ScheduleReminder {...reminder} />
                </div>
            </Grid>
        </Grid>
    );
}
